<template>
  <div class="d-flex position-relative">
    <v-chip
      v-for="(question, key) in questions"
      :key="key"
      x-small
      :color="activeTab !== key ? 'default' : 'active'"
      class="w-100 py-1 pointer-on-hover border-0"
      :class="{
        'mr-1' : key<questions.length - 1
      }"
      style="height: 10px"
      @click="$emit('input',key)"
    />
  </div>
</template>

<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: Number,
      required: true,
    }
  }
}
</script>
<style scoped>
.active {
  background-color: #0d6cf9 !important;
}
</style>
